export default "__VITE_ASSET__Bi58JRUP__"